import { Chat, Wifi, WifiOff } from '@mui/icons-material';
import { Badge, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
export const AppStatus = () => {
    const onLine = useSelector((state: RootState) => state.document.onLine);
    const connected = useSelector((state: RootState) => state.broadcaster.connected);
    return <div className='no-print' style={{ position: 'fixed', bottom: 0, right: 0, padding: '1em' }}>
        <Stack direction="row" spacing={1}>
            <Badge title="Connexion internet" color={'error'} badgeContent={onLine ? undefined : ':('}>
                {onLine ? <Wifi fontSize='small' color='success' /> : <WifiOff fontSize='small' color='action' />}
            </Badge>
            <Badge title='Discussion instantanée' color={'error'} badgeContent={connected ? undefined : ':('}>
                <Chat fontSize='small' color={connected ? 'success' : 'action'} />
            </Badge>
        </Stack>
    </div>;
};
